import { Button, Center, Img, Skeleton, Spacer, Text, Textarea, VStack } from '@chakra-ui/react';
import React from 'react';
import useModelAvaliacaoAtendimento from './useModelAvaliacaoAtendimento';
import StarRating from 'components/Perfil/Historico/StartRating';
import AvaliacaoTelemed from '../../../../../../images/AvaliacaoTelemed.svg';
import ModalSuporte from 'components/Perfil/ModalSuporte';
import ModalAvaliacaoLoja from 'components/AvaliacaoLoja/AvaliacaoLoja';

function AvalicaoAtendimento() {
  const {
    avaliacaoAtendimento,
    error,
    loading,
    theme,
    rating,
    setRating,
    opnion,
    setOpnion,
    assinante,
    modalSuporte,
    navigate,
    agendamento,
    loadingAva,
    liberarDashboard,
    modalAvaliacaoLoja,
    agenda_exames_id
  } = useModelAvaliacaoAtendimento();

  if (loading) {
    return (
      <>
        <Center minH="100vh" bg={theme.background}>
          <VStack p={4} bg="white" boxShadow="md" m={'5%'} borderRadius="0.8em">
            <VStack mb={'5%'} m={'5%'} textAlign={'center'}>
              <Img src={AvaliacaoTelemed} />
              <Text color="#474747" fontWeight="bold" fontSize="1.2em" as={Skeleton}>
                Seu atendimento foi concluído!
              </Text>
              <Text color="#474747" fontWeight="bold" fontSize="1em" as={Skeleton}>
                Avalie seu atendimento com médico...
              </Text>
            </VStack>
            <VStack w={'100%'} bg={'#E5E5E5'} borderRadius={'0.8em'} p={4} as={Skeleton}>
              <Spacer mt={'5%'} />
              <StarRating alignItems="center" rating={rating} setRating={setRating} color={'#D2D2D2'} />
              <Spacer />
              <Text color="#00000" fontWeight={'bold'} fontSize={'1.2em'} as={Skeleton}>
                Deixe seu comentário
              </Text>
              <VStack w={'100%'} m={'5%'}>
                <Textarea
                  background={'#D9D9D9'}
                  placeholder="Descreva aqui sua experiência"
                  value={opnion}
                  onChange={(e) => setOpnion(e.target.value)}
                  as={Skeleton}
                />
              </VStack>
            </VStack>
            {!loading && !error && (
              <>
                <Button as={Skeleton} bg={theme.background} color="white" fontWeight="bold" w={'100%'}>
                  Avaliar
                </Button>
              </>
            )}

            {error && (
              <>
                <Text color="red.400" fontWeight={'bold'} textAlign={'center'} as={Skeleton}>
                  Houve um erro ao enviar sua avaliação.
                </Text>
                <Button bg={'yellow.400'} loading={loading} disabled={loading} color="white" fontWeight="bold" w={'100%'} as={Skeleton}>
                  Falar com o suporte
                </Button>
                <Button bg={theme.background} loading={loading} disabled={loading} color="white" fontWeight="bold" w={'100%'} as={Skeleton}>
                  Ir para a home
                </Button>
              </>
            )}
            {!loading && liberarDashboard && (
              <Button bg={theme.background} color="white" fontWeight="bold" w={'100%'} onClick={() => navigate('/dashboard')}>
                Ir para a home
              </Button>
            )}
          </VStack>
        </Center>
      </>
    );
  }



  return (
    !loading && (
      <>
        <ModalAvaliacaoLoja disclosure={modalAvaliacaoLoja} agenda_exames_id={agenda_exames_id}/>
        <ModalSuporte disclosure={modalSuporte} />
        <Center minH="100vh" bg={theme.background}>
          <VStack p={4} bg="white" boxShadow="md" m={'5%'} borderRadius="0.8em">
            <VStack mb={'5%'} m={'5%'} textAlign={'center'}>
              <Img src={AvaliacaoTelemed} />
              <Text color="#474747" fontWeight="bold" fontSize="1.2em">
                Seu atendimento foi concluído!
              </Text>
              <Text color="#474747" fontWeight="bold" fontSize="1em">
                Avalie seu atendimento com {agendamento?.medico}
              </Text>
            </VStack>
            <VStack w={'100%'} bg={'#E5E5E5'} borderRadius={'0.8em'} p={4}>
              <Spacer mt={'5%'} />
              <StarRating alignItems="center" rating={rating} setRating={setRating} color={'#D2D2D2'} />
              <Spacer />
              <Text color="#00000" fontWeight={'bold'} fontSize={'1.2em'}>
                Deixe seu comentário
              </Text>
              <VStack w={'100%'} m={'5%'}>
                <Textarea
                  background={'#D9D9D9'}
                  placeholder="Descreva aqui sua experiência"
                  value={opnion}
                  onChange={(e) => setOpnion(e.target.value)}
                />
              </VStack>
            </VStack>
            {!loadingAva && !error && (
              <>
                <Button bg={theme.background} color="white" fontWeight="bold" w={'100%'} onClick={avaliacaoAtendimento}>
                  Avaliar
                </Button>
              </>
            )}

            {loadingAva && !error && (
              <>
                <Text color="green" fontWeight="bold" w={'100%'} textAlign="center">
                  Enviando avaliação...
                </Text>
              </>
            )}

            {error && (
              <>
                <Text color="red.400" fontWeight={'bold'} textAlign={'center'}>
                  Houve um erro ao enviar sua avaliação.
                </Text>
                <Button bg={'yellow.400'} color="white" fontWeight="bold" w={'100%'} onClick={() => modalSuporte.onOpen()}>
                  Falar com o suporte
                </Button>
                <Button bg={theme.background} color="white" fontWeight="bold" w={'100%'} onClick={() => navigate('/dashboard')}>
                  Ir para a home
                </Button>
              </>
            )}
            {!loading && liberarDashboard && (
              <Button bg={theme.background} color="white" fontWeight="bold" w={'100%'} onClick={() => navigate('/dashboard')}>
                Ir para a home
              </Button>
            )}
          </VStack>
        </Center>
      </>
    )
  );
}

export default AvalicaoAtendimento;
